import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import notificationReducer from './slices/notificationSlice';
import themeReducer from './slices/themeSlice';
import favoritesReducer from './slices/favoritesSlice';
import comparisonReducer from './slices/comparisonSlice';
import { apiSlice } from './slices/apiSlice';
import { adminApiV2Slice } from './slices/admin/adminApiSlice';
import { authMiddlewareWithRetry } from './middleware/authMiddleware';
import { cartValidationMiddleware } from './middleware/cartValidationMiddleware';

// Vendor API Slices
import vendorAuthApi from './slices/vendor/vendorAuthApi';
import vendorDashboardApi from './slices/vendor/vendorDashboardApi';
import vendorListingsApi from './slices/vendor/vendorListingsApi';
import vendorOrdersApi from './slices/vendor/vendorOrdersApi';
import vendorExtensionsApi from './slices/vendor/vendorExtensionsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    notification: notificationReducer,
    theme: themeReducer,
    favorites: favoritesReducer,
    comparison: comparisonReducer,
    api: apiSlice.reducer,
    adminApiV2: adminApiV2Slice.reducer,
    // Vendor API reducers
    vendorAuthApi: vendorAuthApi.reducer,
    vendorDashboardApi: vendorDashboardApi.reducer,
    vendorListingsApi: vendorListingsApi.reducer,
    vendorOrdersApi: vendorOrdersApi.reducer,
    vendorExtensionsApi: vendorExtensionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(
      apiSlice.middleware,
      adminApiV2Slice.middleware,
      // Vendor API middlewares
      vendorAuthApi.middleware,
      vendorDashboardApi.middleware,
      vendorListingsApi.middleware,
      vendorOrdersApi.middleware,
      vendorExtensionsApi.middleware,
      authMiddlewareWithRetry,
      cartValidationMiddleware // Cart market validation
    ),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
